import React from 'react';
import { AppList } from "components/list/AppList";
import { 
	Datagrid, ReferenceField, 
	TextField,
} from 'react-admin';

import { ScrollingWrapper } from '../../../components/ScrollingWrapper';
import { DatagridWithBlockProps } from '../../../components/_helpers/props/DatagridProps';
import { DateTimeFormatField } from '../../../components/fields/DateFormatField';

import { BackupLogPricelistFilter } from './ListFilters';


const defaultSort = { field: 'id', order: 'DESC' };


export const BackupLogPricelistList = (props) => (
	<AppList
		{...props}
		sort={defaultSort}
		exporter={false}
		bulkActionButtons={false}
		filters={<BackupLogPricelistFilter />}
	>
		<ScrollingWrapper>
			<Datagrid {...DatagridWithBlockProps} rowClick='show'>
				<TextField source='id' />
				<TextField source='version' />
				<DateTimeFormatField source='created_at' />

				<ReferenceField source='created_by' reference='users' link={false}>
					<TextField source='first_name' />
				</ReferenceField>

				<ReferenceField source='terminal_id' reference='terminal' link={false}>
					<TextField source='name' />
				</ReferenceField>

				<TextField source='file_path' />
			</Datagrid>
		</ScrollingWrapper>
	</AppList>
);
